import { render, staticRenderFns } from "./InfrastructureCybersecurity.vue?vue&type=template&id=22d5cdd4&"
import script from "./InfrastructureCybersecurity.vue?vue&type=script&lang=js&"
export * from "./InfrastructureCybersecurity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports